<template>

    <div class="img-animate" id="animation_container_logo">
        <img class="size_holder" src="/static/animations/images/holder405x160.png" />
        <canvas id="canvas_logo" class="canvas_inner" width="405" height="160"></canvas>
        <div id="dom_overlay_container_logo"></div>
    </div>

</template>


<script>

export default {

    name: 'AnimatedLogo',

    data() {
        return {

        }
    },

    created() {

    },

    mounted() {

        this.init_logo();

    },

    methods: {

        init_logo() {
            var canvas, stage, exportRoot, anim_container, dom_overlay_container, fnStartAnimation;

            canvas = document.getElementById("canvas_logo");
            anim_container = document.getElementById("animation_container_logo");
            dom_overlay_container = document.getElementById("dom_overlay_container_logo");
            // eslint-disable-next-line
            var comp = AdobeAn.getComposition("861DD870014444B8B6ACD6E1BCA7C67C");
            // eslint-disable-next-line
            var logo_lib = comp.getLibrary();
            handleComplete({}, comp);

            function handleComplete(evt, comp) {
                //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
                var logo_lib=comp.getLibrary();
                // eslint-disable-next-line
                var ss=comp.getSpriteSheet();

                exportRoot = new logo_lib.logo_32_jb();
                window.logoAnimation = exportRoot;

                stage = new logo_lib.Stage(canvas);
                //Registers the "tick" event listener.
                fnStartAnimation = function() {
                    stage.addChild(exportRoot);
                    // eslint-disable-next-line
                    createjs.Ticker.setFPS(logo_lib.properties.fps);
                    // eslint-disable-next-line
                    createjs.Ticker.addEventListener("tick", stage);
                };
                //Code to support hidpi screens and responsive scaling.
                function makeResponsive(isResp, respDim, isScale, scaleType) {
                    var lastW, lastH, lastS = 1;
                    window.addEventListener('resize', resizeCanvas);
                    resizeCanvas();
                    function resizeCanvas() {
                        var w = logo_lib.properties.width, h = logo_lib.properties.height;
                        var iw = window.innerWidth, ih = window.innerHeight;
                        var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio=1;
                        if (isResp) {
                            if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                                sRatio = lastS;
                            } else if (!isScale) {
                                if (iw < w || ih < h)
                                    sRatio = Math.min(xRatio, yRatio);
                            } else if (scaleType == 1) {
                                sRatio = Math.min(xRatio, yRatio);
                            } else if (scaleType == 2) {
                                sRatio = Math.max(xRatio, yRatio);
                            }
                        }
                        canvas.width = w*pRatio * sRatio;
                        canvas.height = h*pRatio * sRatio;
                        canvas.style.width = dom_overlay_container.style.width = anim_container.style.width =  w * sRatio + 'px';
                        canvas.style.height = anim_container.style.height = dom_overlay_container.style.height = h * sRatio + 'px';
                        stage.scaleX = pRatio * sRatio;
                        stage.scaleY = pRatio * sRatio;
                        lastW = iw;
                        lastH = ih;
                        lastS = sRatio;
                        stage.tickOnUpdate = false;
                        stage.update();
                        stage.tickOnUpdate = true;
                    }
                }
                makeResponsive(false, 'both' ,false ,1);
                // eslint-disable-next-line
                AdobeAn.compositionLoaded(logo_lib.properties.id);
                fnStartAnimation();
            }
        }

    }

}

</script>


<style lang="scss" scoped>

    #animation_container_logo {
        width: 100% !important;
        height: auto !important;
        top: 0;
        left: 0;
        position: relative;
    }

    #canvas_logo {
        position: absolute;
        display: block;
    }

    .canvas_inner {
        width: 100% !important;
        height: 100% !important;
        top: 0;
    }

    #dom_overlay_container_logo {
        pointer-events: none;
        overflow: hidden;
        width: inherit !important;
        height: inherit !important;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
    }

    .size_holder {
        width: 100%;
        height: auto;
        position: relative;
    }

</style>
